module.exports = __webpack_public_path__ + "static/img/tom_g.ee1448ce.png";